import { render, staticRenderFns } from "./IconCoin.vue?vue&type=template&id=0806d1a6&scoped=true"
import script from "./IconCoin.vue?vue&type=script&lang=js"
export * from "./IconCoin.vue?vue&type=script&lang=js"
import style0 from "./IconCoin.vue?vue&type=style&index=0&id=0806d1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806d1a6",
  null
  
)

export default component.exports